import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {PaymentIntent} from '../types';
import {stage} from "../../../config/stage";


export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<PaymentIntent, 'id'>,
    handleSubmit: (values: PaymentIntent) => void,
    handleCancel?: () => void
}) => {

    const onSubmit = (values: PaymentIntent) => {
        handleSubmit(values);
    };

    const onCancel = () => {
        handleCancel?.();
    };


    let initialValues = {
        amount: 0,
        currency: 'usd',
        description: '',
        customerId: '',
        automaticPaymentMethods: {
            enabled: true,
        },
        setupFutureUsage: 'offSession',
    } as PaymentIntent;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
